export type HeadersObject = Record<string, string | string[] | undefined>;
export type HeadersInput = HeadersObject | globalThis.Headers | Array<[string, string]>;

export function headersToObject(headers: HeadersInput): HeadersObject {
    if (Array.isArray(headers)) {
        headers = new Headers(headers);
    }

    if (headers instanceof Headers) {
        return Object.fromEntries(headers);
    }

    return headers;
}
